import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { tap, catchError, of, lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { EnvConfig } from '../models/env-config.model';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  private http = inject(HttpClient);

  public isLoaded = signal(false);
  public error = signal<string | null>(null);

  loadConfig() {
    if (!environment.production && environment.env !== 'dev') {
      this.isLoaded.set(true);
      return of(null);
    }

    return this.http.get<EnvConfig[]>(`${environment.bff_service}/api/front-envs`).pipe(
      tap(configArray => {
        const config: Record<string, string> = {};
        configArray.forEach(item => {
          config[item.key] = item.value;
        });

        Object.keys(environment).forEach(key => delete (environment as any)[key]);
        Object.assign(environment, config);
        this.isLoaded.set(true);
      }),
      catchError(err => {
        console.error('Failed to load config:', err);
        this.error.set(err.message);
        this.isLoaded.set(true);
        return of(null);
      })
    );
  }

  async initialize(): Promise<void> {
    await lastValueFrom(this.loadConfig());
  }
}
